/**
 * Diffère un travail hors du chemin critique clic → peinture (INP).
 */
export function scheduleIdleWork(callback, timeoutMs = 1200) {
  if (typeof callback !== 'function') return () => {};
  if (typeof window === 'undefined') {
    callback();
    return () => {};
  }
  if (typeof window.requestIdleCallback === 'function') {
    const idleId = window.requestIdleCallback(() => callback(), { timeout: timeoutMs });
    return () => {
      if (typeof window.cancelIdleCallback === 'function') {
        window.cancelIdleCallback(idleId);
      }
    };
  }
  const timerId = window.setTimeout(callback, 0);
  return () => window.clearTimeout(timerId);
}
